;(function (global, factory) {
    typeof define === 'function' && define.amd ? define('score_bootstrap/Utils/window',[], factory) :
    typeof exports === 'object' && typeof module !== typeof void 0 ? module.exports = factory() :
    console && console.error('Window does not support non-amd script loading.');
}(this/* window */, function() {
    return this; /* window */
}));
